import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { GenericPaymentListProps } from "models/propTypes/paymentPropTypes";
import { Amount } from "models/utilTypes/currencyType";
//#endregion
//#region components
import PaymentList from "../paymentListTable";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const PayoutFilesList: React.FC<GenericPaymentListProps> = (props) => {
  return (
    <PaymentList
      properties={{
        paymentType: {
          description: TranslationKeys.Common.Type,
          formatter: () => LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Payment),
          noWrap: true,
          width: "20%",
        },
        date: {
          description: TranslationKeys.Common.Date,
          formatter: (values: WintSuperkollAPIModel.BankPaymentListItem) => values.date && new Date(values.date),
          noWrap: true,
          width: "55%",
        },
        amount: {
          formatter: (values: WintSuperkollAPIModel.BankPaymentListItem) =>
            values.amount && new Amount(values.amount.type, values.amount.value),
          description: TranslationKeys.Common.Amount,
          noWrap: true,
          className: cssExports.textBlack,
          alignment: "right",
          width: "25%",
        },
      }}
      items={props.items ?? []}
      onRowSelectionsChange={props.onRowSelectionsChange}
    ></PaymentList>
  );
};

export default PayoutFilesList;
